<template>
  <div class="reverso-model-list">
    <div>
      <el-form ref="refSearchForm" :model="queryParams" label-width="70px" inline style="display: flex;">
        <el-form-item label="规格名称">
          <el-input v-model="queryParams.modelKey" size="small" clearable placeholder="请输入规格名称"
                    style="width: 140px"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="queryParams.productName" size="small" clearable placeholder="请输入产品名称"
                    style="width: 140px"></el-input>
        </el-form-item>
        <el-button style="margin-bottom: 15px;" type="primary" size="small" round icon="el-icon-search"
                   @click="getPageList()">搜索
        </el-button>
        <el-button style="margin-bottom: 15px;" type="primary" size="small" round @click="onClickClear">重置</el-button>
        <el-button style="margin-bottom: 15px;" type="primary" size="small" round icon="el-icon-circle-plus-outline"
                   @click="onClickAdd">新增
        </el-button>
        <el-button style="margin-bottom: 15px;" type="primary" size="small" round @click="onClickDown">下载模板
        </el-button>
        <el-upload
            action="/api/resource-tendering/api/v1/translation/model/uploadExcel"
            :show-file-list="false"
            :headers="headers"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :on-success="handleBannerSuccess"
            :on-error="handleBannerError"
            :before-upload="beforeBannerUpload"
            style="height: 32px;line-height: 13px;"
        >
          <el-button style="margin-bottom: 10px;margin-left: 10px" type="primary" size="small" round
                     icon="el-icon-circle-plus-outline"> 导入
          </el-button>
        </el-upload>
        <el-button style="margin-bottom: 15px;margin-left: 10px" type="primary" size="small" round @click="onClickPublic"> 一键发布
        </el-button>
      </el-form>

    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            @select-all="onChangeTableAll"
            @selection-change="onChangeTableSelection"
            :data="tableData"
            border>
          <el-table-column
              type="selection"
              align="center"
              width="45">
          </el-table-column>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="uuid"
              show-overflow-tooltip
              align="center"
              label="ID">
          </el-table-column>
          <el-table-column
              prop="productName"
              show-overflow-tooltip
              align="center"
              label="产品名称">
          </el-table-column>
          <el-table-column
              prop="modelKey"
              show-overflow-tooltip
              align="center"
              label="规格型号">
          </el-table-column>
          <el-table-column
              prop="customName"
              show-overflow-tooltip
              align="center"
              label="客户名称">
          </el-table-column>
          <el-table-column
              prop="status"
              show-overflow-tooltip
              align="center"
              label="状态"
              width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==='1'" type="success">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
              <el-tag v-else type="info">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="shelfLife"
              show-overflow-tooltip
              align="center"
              label="质保期">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              label="创建时间">
          </el-table-column>
          <el-table-column label="操作" align="center" width="140">
            <template slot-scope="scope">
              <el-button
                  :loading="dialogTemplateEditLoading"
                  type="text" @click="onClickEdit(scope.row)">编辑
              </el-button>
              <el-button
                  v-if="scope.row.status==='2'||scope.row.status==='0'"
                  :loading="dialogTemplateLoading"
                  type="text" @click="onClickPublish(scope.row)">发布
              </el-button>
              <el-button
                  v-if="scope.row.status==='1'"
                  :loading="dialogTemplateLoading"
                  type="text" @click="onClickCannel(scope.row)">撤销
              </el-button>
              <el-button
                  v-if="scope.row.status==='0'||scope.row.status==='2'"
                  :loading="dialogTemplateLoading"
                  type="text" @click="onClickDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @size-change="handleSizeChange"
            @current-change="onChangeCurrent"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            :page-sizes="pageSizes"
            background
            layout="total, prev, pager, next, sizes"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
    </div>
    <el-dialog
        class="dialog-code-box"
        append-to-body
        destroy-on-close
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="dialogTemplateVisible"
        width="1000px">
      <div class="dialog-info-box">
        <el-tabs v-model="dialogTemplateActive" @tab-click="handleClick">
          <el-tab-pane label="产品规格信息" name="product"></el-tab-pane>
        </el-tabs>
        <div>
          <div v-show="dialogTemplateActive==='product'">
            <el-form :model="dialogProductForm" :rules="dialogProductRule" ref="refDialogProduct"
                     label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="产品名称" prop="productName">
                    <el-input v-model="dialogProductForm.productName"
                              placeholder="请输入产品名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户名称" prop="customName">
                    <el-input v-model="dialogProductForm.customName"
                              placeholder="请输入客户名称"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="规格型号" prop="modelKey">
                    <el-input v-model="dialogProductForm.modelKey"
                              placeholder="请输入规格型号"></el-input>
                  </el-form-item>
                </el-col>


                <el-col :span="12">
                  <el-form-item label="产品封面" prop="productPicUrl">
                    <el-upload
                        list-type="picture-card"
                        v-model="dialogProductForm.productPicUrl"
                        :file-list="dialogProductImgList"
                        action="/service-center/upload/file/single"
                        :headers="headers"
                        :disabled="dialogTemplateDisabled"
                        :before-upload="(file)=>handleBeforeUpload(file,'dialogProductImgList')"
                        :on-preview="handleCardPreview"
                        :on-remove="(file, fileList)=>handleBusinessRemove(file, fileList,'dialogProductImgList')"
                        :on-change="(file, fileList)=>handleBusinessChange(file, fileList,'dialogProductImgList')"
                        :on-success="(response,file, fileList)=>handleBusinessSuccess(response,file, fileList,'dialogProductImgList')">
                      <i class="el-icon-plus"></i>
                      <div v-if="!dialogTemplateDisabled" class="el-upload__tip" slot="tip">
                        图片规格：590*375且不超过2M
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品说明" prop="templeModel">
                    <el-select v-model="dialogProductForm.templeModel" placeholder="请选择产品说明" style="width: 300px;"
                               filterable
                               remote
                               reserve-keyword
                               :remote-method="remoteMethod"
                               clearable
                               @change="changeTempleInfo"
                    >
                      <el-option v-for="(item, index) in  templeMapSelect" :label="item.name" :key="item.uuid"
                                 :value="item.uuid">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">

                <el-col :span="12">
                  <el-form-item label="证书名称" prop="licenseNumber">
                    <el-input v-model="dialogProductForm.licenseNumber"
                              placeholder="请输入证书名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="执行标准" prop="productStandard">
                    <el-input v-model="dialogProductForm.productStandard"
                              placeholder="请输入执行标准"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="批号" prop="lotNumber">
                    <el-input v-model="dialogProductForm.lotNumber" placeholder="请输入批号"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="流量" prop="flowRate">
                    <el-input v-model="dialogProductForm.flowRate" placeholder="请输入流量">
                      <template slot="append">m³/h</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="功率" prop="powerValue">
                    <el-input v-model="dialogProductForm.powerValue" placeholder="请输入功率">
                      <template slot="append">kw</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="扬程" prop="headValue">
                    <el-input v-model="dialogProductForm.headValue" placeholder="请输入扬程">
                      <template slot="append">m</template>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="效率" prop="efficiency">
                    <el-input v-model="dialogProductForm.efficiency" placeholder="请输入效率">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="转速" prop="rotateSpeed">
                    <el-input v-model="dialogProductForm.rotateSpeed" placeholder="请输入转速">
                      <template slot="append">r/min</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="频率" prop="frequencyValue">
                    <el-input v-model="dialogProductForm.frequencyValue"
                              placeholder="请输入频率">
                      <template slot="append">Hz</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="重量" prop="weightValue">
                    <el-input v-model="dialogProductForm.weightValue" placeholder="请输入重量">
                      <template slot="append">Kg</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="温升" prop="temperatureRise">
                    <el-input v-model="dialogProductForm.temperatureRise"
                              placeholder="请输入温升">
                      <template slot="append">K</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="额定电流" prop="eleValue">
                    <el-input v-model="dialogProductForm.eleValue"
                              placeholder="请输入额定电流">
                      <template slot="append">A</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="额定电压" prop="voltageValue">
                    <el-input v-model="dialogProductForm.voltageValue"
                              placeholder="请输入额定电压">
                      <template slot="append">V</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="高度" prop="heightValue">
                    <el-input v-model="dialogProductForm.heightValue"
                              placeholder="请输入高度">
                      <template slot="append">M</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="外径" prop="radiusValue">
                    <el-input v-model="dialogProductForm.radiusValue"
                              placeholder="请输入外径">
                      <template slot="append">mm</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="质保期" prop="shelfLife">
                    <el-input v-model="dialogProductForm.shelfLife"
                              placeholder="请输入质保期">
                      <template slot="append">天</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClickCodeCancel">取 消</el-button>
        <el-button v-if="!dialogTemplateDisabled" size="small" type="primary"
                   :loading="dialogTemplateLoading" @click="onClickCodeSubmit">提 交
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {
  deleteTranslationModel,
  getTranslationModelDetail,
  getTranslationModelList,
  saveTranslationModel,
  selectTemplateList,
  single,
  updateTranslationModelStatus, updateTranslationModelStatusBatch
} from "../../utils/interface";

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      pageSizes: [10,20,50,100,500],
      multipleSelection: [],
      headers: {
        'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
      },
      tableData: [],
      queryParams: {
        productName: '',
        productPicUrl: '',
        current: 1,
        pageSize: 10,
        total: 0,
      },
      templeParams: {
        status: 1,
      },
      enumStatus: [{
        value: '1',
        name: '已发布',
      }, {
        value: '2',
        name: '待发布',
      }, {
        value: '0',
        name: '撤销',
      }],
      listLoading: false,
      dialogTemplateActive: 'product',
      dialogTemplateRow: {},
      dialogTemplateVisible: false,
      dialogTemplateDisabled: false,
      dialogTemplateLoading: false,
      dialogTemplateEditLoading: false,
      dialogProductImgList: [],
      dialogProductForm: {
        uuid: "",
        productName: "",
        customName: "",
        productPicUrl: '',
        modelKey: '',
        flowRate: '',
        rotateSpeed: '',
        headValue: '',
        powerValue: '',
        efficiency: '',
        weightValue: '',
        temperatureRise: '',
        frequencyValue: '',
        eleValue: '',
        voltageValue: '',
        otherSysModel: '',
        licenseNumber: '',
        productStandard: '',
        heightValue: '',
        radiusValue: '',
        shelfLife: 365,
        lotNumber: '',
        status: 0,
        templeUuid: '',
        templeModel: '',
      },
      dialogProductRule: {
        productName: [
          {required: true, message: '请输入产品名称', trigger: 'blur'},
        ],
        modelKey: [
          {required: true, message: '请输入规格型号', trigger: 'blur'},
        ],
        // productPicUrl: [
        //   {required: true, message: '请上传产品图', trigger: 'blur'},
        //   {required: true, message: '请上传产品图', trigger: 'change'},
        // ],
        templeModel: [
          {required: true, message: '请选择产品说明', trigger: 'blur'},
        ],
      },
      templeMap: [], // 产品说明下拉框
      templeMapSelect: [], // 产品说明下拉框-筛选结果
    }
  },
  created() {

  },
  methods: {
    initData() {
      this.getPageList()
      this.getOptionsData()
      this.getTempleList()
    },
    getPageList() {
      this.listLoading = true
      getTranslationModelList(this.queryParams).then((res) => {
        this.listLoading = false
        if (res.list) {
          this.tableData = res.list
          this.queryParams.total = res.total
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getOptionsData() {

    },
    getTempleList() {
      this.listLoading = true
      selectTemplateList(this.templeParams).then((res) => {
        this.listLoading = false
        if (res) {
          this.templeMap = res
          this.templeMapSelect = res
        }
      }).catch(err => {
        this.listLoading = false
      })
    },


    changeTempleInfo(key) {

      let item = this.templeMap.find(item => item.uuid === key)

      if (undefined != item) {
        this.dialogProductForm.templeUuid = item.uuid
      } else {
        this.templeMapSelect = this.templeMap
      }
    },
    remoteMethod(query) {
      if (query != '') {
        this.templeMapSelect = []
        for (let i in this.templeMap) {
          // 模糊查询且不区分大小写
          if (this.templeMap[i].name.indexOf(query) != -1) { //未匹配成功时返回-1
            this.templeMapSelect.push(this.templeMap[i])
          }
        }
      } else {
        for (let i in this.templeMap) {
          this.templeMapSelect.push(this.templeMap[i])
        }
      }
    },
    handleBannerSuccess(res) {
      console.log("------------res-------------");
      console.log(res);
      this.loading = false;
      if (!res.success) {
        let message = res.message + "<br>";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: message,
          type: "error",
        });
      } else {
        this.getPageList();
      }
    },
    handleBannerError(res){
      console.log("------------res-------------");
      console.log(res);
      this.loading = false;
      if (!res.success) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: res.message,
          type: "error",
        });
      } else {
        this.getPageList();
      }
    },
    beforeBannerUpload(file) {
      this.loading = true;

      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
        this.$message.warning("上传文件只能为excel文件，且为xlsx,xls格式!");
        this.loading = false;
        return false;
      }
    },
    onClickAdd() {
      this.dialogTemplateVisible = true
      this.$nextTick(() => {
        this.dialogClearData()
      })
    },
    onClickDown() {
      let a = document.createElement("a");
      a.href = "/static/modelExcel.xls";
      // a.download = "产品型号导入模板.xls";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    onClickEdit(row) {
      this.dialogTemplateEditLoading = true
      this.dialogTemplateRow = row
      getTranslationModelDetail(row.uuid).then((res) => {
        this.dialogTemplateEditLoading = false
        if (res.data) {
          let data = res.data
          this.dialogTemplateVisible = true
          this.$nextTick(() => {
            this.dialogClearData()
            this.dialogProductForm = {
              uuid: row.uuid,
              productName: data.productName,
              customName: data.customName,
              modelKey: data.modelKey,
              productPicUrl: data.productPicUrl,
              flowRate: data.flowRate,
              rotateSpeed: data.rotateSpeed,
              headValue: data.headValue,
              powerValue: data.powerValue,
              efficiency: data.efficiency,
              weightValue: data.weightValue,
              temperatureRise: data.temperatureRise,
              frequencyValue: data.frequencyValue,
              otherSysModel: data.otherSysModel,
              licenseNumber: data.licenseNumber,
              productStandard: data.productStandard,
              lotNumber: data.lotNumber,
              status: data.status,
              templeUuid: data.templeUuid,
              templeModel: data.templeUuid,
              eleValue: data.eleValue,
              voltageValue: data.voltageValue,
              heightValue: data.heightValue,
              radiusValue: data.radiusValue,
              shelfLife: data.shelfLife || 365,
            }
            if (null != data.productPicUrl && data.productPicUrl != '') {
              this.dialogProductImgList.push({name: 'file', url: data.productPicUrl})
            }
          })
        }
      }).catch(err => {
        this.dialogTemplateEditLoading = false
      })
    },
    onClickPublish(row) {
      // 发布功能
      this.dialogTemplateLoading = true
      updateTranslationModelStatus(row.uuid, 1).then((res) => {
        this.dialogTemplateLoading = false
        this.$message({
          type: res.success ? "success" : "warning",
          message: res.message,
        })
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateLoading = false
      })
    },
    onClickCannel(row) {
      // 撤回功能
      this.dialogTemplateLoading = true
      updateTranslationModelStatus(row.uuid, 0).then((res) => {
        console.log("--------------------")
        console.log(res)
        this.dialogTemplateLoading = false
        this.$message({
          type: res.success ? "success" : "warning",
          message: res.message,
        })
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateLoading = false
      })
    },
    onClickDelete(row) {
      // 撤回功能
      this.dialogTemplateLoading = true
      deleteTranslationModel(row.uuid).then((res) => {
        this.dialogTemplateLoading = false
        this.$message({
          type: res.success ? "success" : "warning",
          message: res.message,
        })
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateLoading = false
      })
    },
    onClickClear() {
      this.$refs['refSearchForm'].resetFields()
      this.queryParams = {
        productName: '',
        modelKey: '',
        current: 1,
        pageSize: 10,
        total: 0,
      }
      this.getPageList()
    },
    onChangeCurrent(e) {
      this.queryParams.current = e
      this.getPageList()
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize
      // 在此刷新数据
      this.getPageList()
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name
    },
    onClickCodeSubmit() {
      let that = this
      this.getDialogUpload('dialogProductImgList', 'dialogProductForm', 'productPicUrl')

      that.$refs.refDialogProduct.validate((valid1) => {
        if (valid1) {
          that.dialogTemplateLoading = true
          let data = {
            ...that.dialogProductForm,
          }
          if (that.dialogTemplateRow && that.dialogTemplateRow.hasOwnProperty('uuid')) {
            data.uuid = that.dialogTemplateRow.uuid
          }
          saveTranslationModel(data).then((res) => {
            that.dialogTemplateLoading = false
            that.onClickCodeCancel()
            that.$message({
              type: res.success ? true : false,
              message: res.message,
            })
            that.getPageList()
          }).catch(err => {
            that.dialogTemplateLoading = false
          })
        } else {
          that.$message.warning('请完善产品规格信息！')
          that.dialogTemplateActive = 'product'
        }
      });
    },
    onClickCodeCancel() {
      this.dialogClearData()
      this.dialogTemplateVisible = false
    },
    getDialogUpload(key0, key1, key2) {
      if (this[key0].length) {
        let file0 = this[key0][0]
        if (file0.response) {
          this[key1][key2] = this[key0][0].response.url
        } else {
          this[key1][key2] = this[key0][0].url || ''
        }
      } else {
        this[key1][key2] = ''
      }
    },
    handleCardPreview(file) {
      this.dialogImgUrl = file.url
      this.dialogImgVisible = true
    },
    handleBeforeUpload(file, key) {
      let that = this
      if (key === 'dialogProductImgList' || key === 'dialogOperateImgList') {
        let isLtSize = file.size / 1024 / 1024 < 2
        if (!isLtSize) {
          this.$message.error('视频（或图片）大小不能超过 2MB!')
          return false
        }

        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (curFile) => {
          const image = new Image()
          image.src = curFile.target.result
          image.onload = () => {
            const {width, height} = image

            const isPNG = /^.png$/.test(file.name.substring(file.name.lastIndexOf('.')));
            const isJPG = /^.jpg$/.test(file.name.substring(file.name.lastIndexOf('.')));

            if (!(isPNG || isJPG)) {
              this.$message.error("图片只能是PNG或JPG格式!");
              that[key] = []
              return false
            } else {
              return true
            }
          }
        }
      }
    },
    handleBusinessChange(file, fileList, key) {
      this[key] = fileList.slice(-1)
    },
    handleBusinessSuccess(response, file, fileList, key) {
      this[key] = fileList
    },
    handleBusinessRemove(file, fileList, key) {
      this[key] = fileList
    },
    handleClick(tab, event) {

    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // console.log('图片上传', );
      var formData = new FormData();
      formData.append("file", file); //第一个file 后台接收的参数名
      let res = await single(formData)
      // console.log('上传成功', res);
      if (res.url) {
        Editor.insertEmbed(cursorLocation, "image", res.url);
        resetUploader();
      } else {
        alert("上传返回失败")
      }
    },
    dialogClearData() {
      this.dialogTemplateActive = 'product'
      this.dialogTemplateDisabled = false
      this.dialogTemplateLoading = false
      this.dialogTemplateRow = {}
      this.dialogProductImgList = []
      this.dialogProductForm = {
        productName: "",
        productPicUrl: '',
        modelKey: '',
        flowRate: '',
        rotateSpeed: '',
        headValue: '',
        powerValue: '',
        efficiency: '',
        weightValue: '',
        temperatureRise: '',
        frequencyValue: '',
        otherSysModel: '',
        licenseNumber: '',
        productStandard: '',
        lotNumber: '',
        radiusValue: '',
        heightValue: '',
        shelfLife: 365,
        status: '',
      }

      this.dialogOperateImgList = []

      this.$refs.refDialogProduct.resetFields()
    },
    onChangeTableSelection(selection) {
      this.multipleSelection = selection
    },
    onChangeTableAll() {
      // this.$refs.refTable.clearSelection()
    },
    onClickPublic(){
      if (this.multipleSelection.length>0){
        let new_arr = this.multipleSelection.map(obj => {return obj.uuid})
        console.info(new_arr)
        updateTranslationModelStatusBatch(new_arr).then((res) => {
          this.dialogTemplateLoading = false
          this.$message({
            type: res.success ? "success" : "warning",
            message: res.message,
          })
          this.getPageList()
        }).catch(err => {
          this.dialogTemplateLoading = false
        })
      }else {
        this.$message({
          type: "warning",
          message: "请选择要发布的规格型号",
        })
      }
    },
  },
};
</script>

<style scoped lang="less">
.reverso-model-list {
  /deep/ .el-button--small.is-round {
    padding: 10px 19px;
  }

  /deep/ .el-form-item {
    margin-bottom: 10px !important;
  }
}
/deep/ .el-input-group__append {
  text-align: center;
  width: 35px;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

///deep/ .el-input-group--append .el-input__inner {
//  border-right: none !important;
//}

/deep/ .el-dialog__body {
  padding: 0 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

/deep/ .el-dialog__header {
  padding: 5px;
}

/deep/ .template-title .el-form-item__label {
  white-space: nowrap;
  margin-right: 20px;
  color: black;
  font-weight: bold;
  font-size: 18px;
}

.template-title {
  white-space: nowrap;
  margin-right: 20px;
  color: black;
  font-weight: bold;
  font-size: 18px;
}

.template-icon:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
  font-weight: normal;
  font-size: 16px;
}

.template-tips {
  color: red;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoModelList.vue